const SITE_KEY = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY?.trim() ?? "";

export function getTurnstileSiteKey(): string {
  return SITE_KEY;
}

export function isTurnstileWidgetEnabled(): boolean {
  return SITE_KEY.length > 0;
}
